<div class="short-message">
    <div class="short-message__inner">

        <shared-header class="short-message__hd" [type]="type" [inverted]="inverted" [marginBottom]="marginBottom"
            [marginTop]="marginTop" *ngIf="title">{{title}}</shared-header>

        <div class="short-message__bd">
            <ng-content></ng-content>
        </div>

        <div class="short-message__ft" *ngIf="button">
            <shared-btn (onClick)="handleClick($event)" [size]="size" [inverted]="inverted" [feel]="feel"
                [iconLeft]="iconLeft" [iconRight]="iconRight" [role]="role" [disabled]="disabled" [width]="width">
                {{button}}</shared-btn>
        </div>

    </div>
</div>